<template>
  <v-app id="backgroundAPP">
    <v-app-bar app color="primary" dark>
      <v-btn class="mr-2" exact :to="{ name: 'Home' }" fab small>
        <v-icon>mdi-home</v-icon>
      </v-btn>
      {{ $t('TBC Admin Portal') }}
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main id="backgroundContent" style="margin-top:20px">
      <div class="title text-center font-weight-bold">{{ $t('404 Not Found') }}</div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "Page404"
};
</script>

<style>
#backgroundContent {
  background-image: url("../assets/404_background.jpg");
  background-position: center;
  background-size:cover;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
#backgroundAPP {
  background: none;
}
</style>
